/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/quotes */
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { CategoryService } from "../category/category.service";
import { SubCategoryService } from "../sub-category/sub-category.service";
import { AddEditQuestionAnswerKeywordComponent } from "./add-edit-question-answer-keyword/add-edit-question-answer-keyword.component";
import { QuestionAnswerKeywordService } from "./question-answer-keyword.service";

const COLS = [
  { value: "qusDescriptionEng", lowercaseValue: "qusDescriptionEng", displayName: "Question (English)" },
  { value: "qusAnswerEng", lowercaseValue: "qusAnswerEng", displayName: "Answer (English)" },
  { value: "qusKeywordEng", lowercaseValue: "qusKeywordEng", displayName: "Keyword (English)" },
  { value: "qusDescriptionMar", lowercaseValue: "qusDescriptionMar", displayName: "Question (मराठी)" },
  { value: "qusAnswerMar", lowercaseValue: "qusAnswerMar", displayName: "Answer (मराठी)" },
  { value: "qusKeywordMar", lowercaseValue: "qusKeywordMar", displayName: "Keyword (मराठी)" },
];

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [];
@Component({
  selector: "app-question-answer-keyword",
  templateUrl: "./question-answer-keyword.component.html",
  styleUrls: ["./question-answer-keyword.component.scss"],
})
export class QuestionAnswerKeywordComponent implements OnInit, AfterViewInit {
  displayedCols = COLS;
  allCols = COLS;
  displayedColumns: any[];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  constructor(
    public dialog: MatDialog,
    private categoryService: CategoryService,
    private subCategoryService: SubCategoryService,
    private _snackBar: MatSnackBar,
    private questionAnswerKeywordService: QuestionAnswerKeywordService
  ) {}

  selectedCategory: any = null;
  categories: any[] = [];

  selectedSubCategory: any = null;
  subCategories: any[] = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.displayedCols = [
      { value: "qusDescriptionEng", lowercaseValue: "qusDescriptionEng", displayName: "Question (English)" },
      { value: "qusAnswerEng", lowercaseValue: "qusAnswerEng", displayName: "Answer (English)" },
      { value: "qusKeywordEng", lowercaseValue: "qusKeywordEng", displayName: "Keyword (English)" },
      { value: "qusDescriptionMar", lowercaseValue: "qusDescriptionMar", displayName: "Question (मराठी)" },
      { value: "qusAnswerMar", lowercaseValue: "qusAnswerMar", displayName: "Answer (मराठी)" },
      { value: "qusKeywordMar", lowercaseValue: "qusKeywordMar", displayName: "Keyword (मराठी)" },
    ];

    this.displayedColumns = this.displayedCols.map((col) => col.value);
    this.getCategories();
  }

  async getCategories() {
    this.categories = [];
    const response: any = await this.categoryService.getCategories();
    console.log(response);
    if (!response.error) {
      if (response.length > 0) {
        this.categories = response;
      } else {
        this.warningToast();
      }
    } else {
      this.errorToast();
    }
  }

  async getSubCategories() {
    this.subCategories = [];
    await this.subCategoryService.getSubCategoriesV1(this.selectedCategory.pkCatid).subscribe((response: any) => {
      console.log(response);
      if (!response.error) {
        if (response.length > 0) {
          this.subCategories = response;
        } else {
          this.warningToast();
        }
      } else {
        this.errorToast();
      }
    });
  }

  async getFaqQuestions() {
    this.dataSource = new MatTableDataSource();
    await this.questionAnswerKeywordService
      .getFaqQuestionsV1(this.selectedCategory.pkCatid, this.selectedSubCategory.pkSucid)
      .subscribe((response: any) => {
        console.log(response);
        if (!response.error) {
          if (response.length > 0) {
            this.dataSource = new MatTableDataSource(response);
            this.dataSource.paginator = this.paginator;
          } else {
            this.warningToast();
          }
        } else {
          this.errorToast();
        }
      });
  }

  addNewSubCategory() {
    const dialogRef = this.dialog.open(AddEditQuestionAnswerKeywordComponent, {
      panelClass: ["custom-popup"],
      width: "50%",
      disableClose: true,
      data: ["New"],
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result == "success") {
        this.getFaqQuestions();
      }
    });
  }

  editSubCategory(data: any) {
    console.log(data);
    const dialogRef = this.dialog.open(AddEditQuestionAnswerKeywordComponent, {
      panelClass: ["custom-popup"],
      width: "50%",
      disableClose: true,
      data: ["Edit", data],
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result == "success") {
        this.getFaqQuestions();
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async warningToast() {
    await this._snackBar.open("No data available for the selection.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast() {
    await this._snackBar.open("Oops, something went wrong, please try after sometime.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }
}
